import React, {useState} from 'react'

interface RuleBuilderStepsHook {
  nextStep: () => void
  prevStep: () => void
  reset: () => void
  setActiveStep: (step: number) => void
  activeStep: number
  isSelected: boolean
  setIsSelected: (isSelected: boolean) => void
}

export function useRuleBuilderSteps({initialStep}: {initialStep: number}): RuleBuilderStepsHook {
  const [activeStep, setActiveStep] = useState<number>(initialStep)
  const [isSelected, setIsSelected] = useState<boolean>(false)

  const nextStep = () => {
    setActiveStep(prev => prev + 1)
  }

  const prevStep = () => {
    setActiveStep(prev => prev - 1)
  }

  const reset = () => {
    setActiveStep(initialStep)
  }

  const setActiveStepIndex = (step: number) => {
    setActiveStep(step)
  }

  return {
    nextStep,
    prevStep,
    reset,
    setActiveStep: setActiveStepIndex,
    activeStep,
    isSelected,
    setIsSelected
  }
}
